import React, {Component} from "react";
import className from "classnames";
import {Button, Col, FormGroup, Input, Label, Modal, ModalBody, ModalFooter, ModalHeader, Row,} from "reactstrap";
import assets from "../../../util/assets";
import {vuepayAlert} from "../../../util/utility";
import "./index.css";

export default class TipModal extends Component {
    constructor(props) {
        super(props);
        this.state = {
            removeCloseButton: false,
            tipValue: 0.01,
            selectedIndex: 0,
            sendTipButtonStatus: false,
            lowBalanceAlert: false,
            dynamicTipData: [
                {
                    amount: 0.01,
                    value: "1p",
                    status: true,
                    text: "Show me love",
                    image: assets.tip.showmelove,
                    right: 55,
                    top: -14
                },
                {
                    amount: 0.10,
                    value: "10p",
                    status: false,
                    text: "Thank me",
                    image: assets.tip.thankme,
                    right: 45,
                    top: -14
                },
                {
                    amount: 0.50,
                    value: "50p",
                    status: false,
                    text: "Wow me",
                    image: assets.tip.wowme,
                    right: 45,
                    top: -14
                },
                {
                    amount: 1,
                    value: "£ 1",
                    status: false,
                    text: "Suprise me",
                    image: assets.tip.impress,
                    right: 45,
                    top: -14
                },
                {
                    amount: 5,
                    value: "£ 5",
                    status: false,
                    text: "Buy me a coffee",
                    image: assets.tip.coffee,
                    right: 45,
                    top: -6
                },
                {
                    amount: 10,
                    value: "£10",
                    status: false,
                    text: "Buy me a meal",
                    image: assets.tip.meal,
                    right: 72,
                    top: -6
                },
                {
                    amount: 25,
                    value: "£25",
                    status: false,
                    text: "Buy me a gift",
                    image: assets.tip.gift,
                    right: 45,
                    top: -16
                },
                {
                    amount: 50,
                    value: "£50",
                    status: false,
                    text: "Impress me",
                    image: assets.tip.impress,
                    right: 45,
                    top: -14
                },
                {
                    amount: -1,
                    value: "other",
                    status: false,
                    text: "Surprise me",
                    image: assets.tip.impress,
                    right: 45,
                    top: -14
                },
            ],
        };
    }

    modalOpenRender = () => {

        setTimeout(() => {
            this.updateTipAmount(this.state.dynamicTipData[0].amount, 0)
        }, 1000);

    };

    componentDidMount() {
        this.modalOpenRender();
    }

    lowBalanceAlert = (floorValue) => {

        let lowBalanceAlert = false;
        // Low Balance alert
        if (Number(this.props.balance) < Number(floorValue)) {
            lowBalanceAlert = true;
        }
        this.setState({
            lowBalanceAlert
        });
    };

    tipValueValidation = (e) => {
        this.setState({
            tipValue: e.target.value == 0 ? '' : Number(e.target.value),
        });

        let floorValue = Math.floor(e.target.value);

        let _findIndex = this.state.dynamicTipData.findIndex(function (tip) {
            if (tip.amount === floorValue)
                return true;
        });

        if (_findIndex === -1) {
            _findIndex = 4;
        }

        this.setState({
            dynamicTipData: this.state.dynamicTipData.map((tip, index) => {
                return _findIndex === index
                    ? {...tip, status: true}
                    : {...tip, status: false};
            }),
        }, () => {
            this.lowBalanceAlert(floorValue);
        });

    };

    handleSubmitTip = () => {
        if (!this.state.lowBalanceAlert) {
            if (this.state.tipValue !== 0 && this.state.tipValue != null) {
                if (this.state.tipValue > 0 && this.state.tipValue <= 100) {
                    this.setState({removeCloseButton: true});
                    this.modalOpenRender();

                    if(this.props.tipAmountSend){
                        //send this to parent class
                        this.props.tipAmountSend(this.state.tipValue);
                    }

                    this.props.tipRequest(
                        Number(this.state.tipValue) * 100,
                        "broadcast_detail"
                    );
                } else {
                    vuepayAlert("error", "Please enter tip value between £1 and £100");
                }
            } else {
                vuepayAlert("error", "Please enter tip value between £1 and £100");
            }
        }
    };

    toggleTipModal = () => {
        if (!this.state.removeCloseButton) {
            this.modalOpenRender();
            this.props.hideTipModal();
        }
    };

    getTipData = (key) => {
        return this.state.dynamicTipData.map((tip) => {
            if (tip.status) {
                return tip[key];
            }
        });
    };


    updateTipAmount = (selectedAmount, index) => {
        this.setState({
            dynamicTipData: this.state.dynamicTipData.map((tip) => {
                return tip.amount === selectedAmount
                    ? {...tip, status: true}
                    : {...tip, status: false};
            }),
        });

        this.lowBalanceAlert(selectedAmount);

        this.setState({
            tipValue: selectedAmount,
            selectedIndex: index
        });
    };

    render() {

        return (
            <Modal isOpen={this.props.showTipModalFlag}
                   toggle={() => this.toggleTipModal}
                   centered
                   className="w-md-75 w-sm-100" style={{width:400}}>

                <ModalHeader
                    toggle={() => {
                        this.props.hideTipModal()
                    }}
                    style={{borderBottom: "1px solid #dee2e6"}}>
                    <span className="tip-modal-header-title">Like</span>
                </ModalHeader>

                <ModalBody className="mt-4 padding-16">
                    <Row className="position-relative">
                        <Col md="11" className="tip-modal-text-bg no-padding">
                            <p className="tip-modal-buy-me-a-coffee">
                                {this.getTipData("text")}
                            </p>
                        </Col>
                        <Col md="1" className="no-margin no-padding tip-modal-image-parent" style={{
                            top: this.state.dynamicTipData[this.state.selectedIndex].top,
                            right: this.state.dynamicTipData[this.state.selectedIndex].right
                        }}>
                            <img src={this.getTipData("image").toString().replace(/,/g, "")} height={72}/>
                        </Col>
                    </Row>
                    <Row className="mt-4">
                        <Col md="12" className="text-left col-12">
                            <FormGroup>
                                <Label className="text-left">
                                    <span className="enter-tip-goal-amount">
                                      Enter like amount
                                    </span>
                                </Label>
                                <Input
                                    className="tip-modal-input"
                                    type="number"
                                    name="tipAmount"
                                    size="lg"
                                    placeholder="0.00"
                                    onChange={this.tipValueValidation}
                                    value={this.state.tipValue}
                                />
                                <Label className="text-left font-italic">
                                    <span className="enter-tip-goal-amount" style={{fontStyle: 'italic', fontSize: 12}}>
                                      NOTE: Please enter an amount between 1p and £100
                                    </span>
                                </Label>
                            </FormGroup>
                        </Col>
                    </Row>
                    <p className="text-left or">
                        OR
                    </p>
                    <p className="text-left please-select-add">
                        Please select & add your top-up amount
                    </p>
                    <Row className="no-margin">
                        {
                            this.state.dynamicTipData.map((tip, index) => {
                                if (tip.amount !== -1) {
                                    return (
                                        <Col md="3" className="px-0 my-sm-2" key={`tip-amount-${index}`}>
                                            <Button
                                                color="primary"
                                                className={className({
                                                    "p-0 tip-modal-top-up-amount-parent": true,
                                                    "amountSelectButtonSize": tip.amount === this.state.tipValue,
                                                    "nonAmountSelectButtonSize": tip.amount !== this.state.tipValue
                                                })}
                                                size="sm"
                                                onClick={() => {
                                                    this.updateTipAmount(tip.amount, index)
                                                }}>
                                            <span className="tip-modal-top-up-amount">
                                                {tip.value}
                                                {" "}
                                                {
                                                    tip.amount === this.state.tipValue &&
                                                    <i className="fa fa-check" aria-hidden="true"></i>
                                                }
                                            </span>
                                            </Button>
                                        </Col>
                                    )
                                }
                            })
                        }
                    </Row>

                    <Row className="mt-4 wallet-balance-rectangle">
                        <Col md="7" className="text-left px-0">
                            <div className="pt-2 mt-1 ml-3 wallet-balance-image-parent">
                                <div>
                                    <img src={assets.add_credit_wallet_outline}
                                         style={{width: "32px", height: "32px", verticalAlign: 'middle'}}/>
                                </div>
                                <div>
                                    <div className="ml-2 wallet-balance-text">Wallet Balance</div>
                                    <div className="ml-2 wallet-balance-amount">£{this.props.balance}</div>
                                </div>
                            </div>
                        </Col>
                        <Col md="5" className="text-right pt-2 mt-1 pl-0">
                            <Button
                                outline
                                color="primary"
                                size="sm"
                                className="p-2 btn btn-outline-primary btn-sm font-weight-light add-credit-button"
                                onClick={this.props.addBalance}>
                                <span className={className({
                                    "add-credit-button-text": true,
                                    "red-color": this.state.lowBalanceAlert
                                })
                                }>
                                      Add credit
                                </span>
                            </Button>
                        </Col>
                    </Row>
                </ModalBody>

                <ModalFooter className="mt-4 padding-16">
                    <Button
                        color="primary tip-modal-send-tip-button"
                        style={this.state.lowBalanceAlert ? {opacity: '0.5'}:{}}
                        onClick={this.handleSubmitTip}>
                        <span className="tip-modal-send-tip-button-text">SEND</span>
                    </Button>
                </ModalFooter>
            </Modal>
        );
    }
}
